import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import _sendAPIRequest, { setErrors } from "../../../../helpers/api";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";
import styles from "./InvitedSuppliers.module.scss";
import { l1_participants_column } from "../../../../elements/CustomDataTable/PortalColumnData";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Button,
  TableCell,
  Typography,
} from "@mui/material";
import { ExpandMore, Watch } from "@mui/icons-material";
import DataTable from "../../../../elements/CustomDataTable/DataTable";
import DeleteDialog from "../../../../elements/CustomDialog/DeleteDialog";
import { PortalApiUrls } from "../../../../helpers/api-urls/PortalApiUrls";
import { AlertContext } from "../../../../contexts/AlertProvider";
import { useDispatch } from "react-redux";
import { setActiveTab } from "../../../../store/tabSlice";
import ScreenLoader from "../../../../elements/CustomScreeenLoader/ScreenLoader";
import { DesktopTimePicker } from "@mui/x-date-pickers";
import classNames from "classnames";

const InvitedSuppliers = ({ onActionComplete, id, type }) => {
  const { handleSubmit, watch } = useForm();
  const dispatch = useDispatch();
  const [screenLoader, setScreenLoader] = useState(true);
  const [bidDetails, setBidDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState({
    open: false,
    title: "",
    message: "",
    alertmessage: "",
    id: null,
    isUndo: false,
  });
  const [participant, setParticipant] = useState();
  const [refresh, setRefresh] = useState(0);
  const [bidDate, setBidDate] = useState(null);
  const [timeRange, setTimeRange] = useState({ start: null, end: null });
  const bidStartDate = watch("bid_start_date");
  const bidEndDate = watch("bid_end_date");
  const { setAlert } = useContext(AlertContext);

  const filteredParticipants = participant?.participants.filter(
    (p) => p.sample?.approval_status === "approved",
  );

  const handleRefresh = () => {
    setRefresh((prevKey) => prevKey + 1); // Increment the refresh key
  };

  useEffect(() => {
    if (id) {
      const getParticipants = async () => {
        try {
          const response = await _sendAPIRequest(
            "GET",
            PortalApiUrls.PARTICIPANTS_LIST + `${id}/`,
            "",
            true,
          );
          if (response.status === 200) {
            setParticipant(response.data);
            setInterval(() => {
              setScreenLoader(false);
            }, 1000);
          }
        } catch (error) {
          console.log(error);
        }
      };

      getParticipants();
    }
  }, [id, refresh]);

  useEffect(() => {
    if (id) {
      let url =
        type === "invited"
          ? PortalApiUrls.RETRIEVE_INVITED_BID
          : PortalApiUrls.RETRIEVE_CREATED_BID;

      const retrieveBid = async () => {
        try {
          const response = await _sendAPIRequest(
            "GET",
            url + `${id}/`,
            "",
            true,
          );
          if (response.status === 200) {
            setBidDetails(response?.data);
          }
        } catch (error) {
          console.log(error);
        }
      };

      retrieveBid();
    }
  }, [id, type, bidDetails?.bid_open_date]);

  const handleAction = async (id, company_name) => {
    try {
      const response = await _sendAPIRequest(
        "PUT",
        `${PortalApiUrls.REVOKE_PARTICIPANT}${id}/`,
        "",
        true,
      );
      if (response.status === 204) {
        setAlert({
          isVisible: true,
          message: `${company_name} Successfully revoked`,
          severity: "success",
        });
        setDeleteDetails({ open: false, title: "", message: "", action: "" });
        handleRefresh();
      }
    } catch (error) {
      const { data } = error.response;
      if (error.status === 403) {
        setAlert({
          isVisible: true,
          message: error.response.data.detail,
          severity: "error",
        });
      }
      if (data) {
        setErrors(data, Watch, setErrors);
        if (data.error) {
          setAlert({
            isVisible: true,
            message: data.error,
            severity: "error",
          });
        }
      }
    }
  };

  const handleUndoRevocation = async (bid_participant_id, company_name) => {
    try {
      const response = await _sendAPIRequest(
        "PUT",
        `${PortalApiUrls.UNDO_PARTICIPANT_REVOCATION}${bid_participant_id}/`,
        "",
        true,
      );
      if (response.status === 204) {
        setAlert({
          isVisible: true,
          message: `${company_name} has been unrevoked successfully.`,
          severity: "success",
        });
        setDeleteDetails({ open: false, title: "", message: "", action: "" });
        handleRefresh();
      }
    } catch (error) {
      setAlert({
        isVisible: true,
        message: "Somthing went wrong",
        severity: "success",
      });
    }
  };

  const handleDeleteConfirmation = (choice) => {
    if (choice) {
      !deleteDetails.isUndo
        ? handleUndoRevocation(deleteDetails.id, deleteDetails.alertmessage)
        : handleAction(deleteDetails.id, deleteDetails.alertmessage);
    } else {
      setDeleteDetails({ open: false, title: "", message: "", action: "" });
    }
  };

  const addAction = (cell) => {
    const isDisabled =
      bidDetails.status === "active" &&
      (cell.row.original.status === "accepted" ||
        cell.row.original?.status === "revoked");

    const isRevoked = cell.row.original?.status === "revoked";
    if (cell.column.id === "action") {
      return (
        <TableCell {...cell.getCellProps()} align="center" padding="none">
          <button
            className={`${styles["table-link"]} ${
              isRevoked ? styles.green : !isDisabled ? styles.gray : styles.red
            }`}
            disabled={!isDisabled}
            onClick={() =>
              setDeleteDetails({
                open: true,
                title: isRevoked
                  ? "Undo Supplier Revocation"
                  : "Revoke Supplier",
                message: `Are you sure you want to ${
                  isRevoked ? "reinstated" : "revoke"
                } ${cell.row.original.company.name} for this bid?.`,
                alertmessage: cell.row.original.company.name,
                id: cell.row.original.id,
                isUndo: isRevoked ? false : true,
              })
            }
          >
            {!isDisabled
              ? `${isRevoked ? "Undo Revoke" : "Revoke"}`
              : isRevoked
                ? "Undo Revoke"
                : "Revoke"}
          </button>
        </TableCell>
      );
    } else {
      return (
        <TableCell {...cell.getCellProps()} align={cell.column.align}>
          {" "}
          {cell.render("Cell")}{" "}
        </TableCell>
      );
    }
  };

  useEffect(() => {
    if (id) {
      let url =
        type === "invited"
          ? PortalApiUrls.RETRIEVE_INVITED_BID
          : PortalApiUrls.RETRIEVE_CREATED_BID;

      const retrieveBid = async () => {
        try {
          const response = await _sendAPIRequest(
            "GET",
            url + `${id}/`,
            "",
            true,
          );
          if (response.status === 200) {
            setBidDetails(response?.data);
          }
        } catch (error) {
          console.log(error);
        }
      };

      retrieveBid();
    }
  }, [id, type, bidDetails?.bid_open_date]);

  const handleTimeChange = (field, value) => {
    if (!value) {
      setTimeRange((prev) => ({ ...prev, [field]: null }));
      return;
    }

    setTimeRange((prev) => {
      // START TIME LOGIC
      if (field === "start") {
        const startTime = dayjs(`${bidDate}T${value}`);

        let updatedEnd = prev.end;

        if (prev.end) {
          const endTime = dayjs(`${bidDate}T${prev.end}`);

          const startIsPM = startTime.hour() >= 12;
          const endIsPM = endTime.hour() >= 12;

          // AM / PM sync only
          if (startIsPM !== endIsPM) {
            const adjustedHour = startIsPM
              ? (endTime.hour() % 12) + 12
              : endTime.hour() % 12;

            updatedEnd = dayjs(endTime).hour(adjustedHour).format("HH:mm");
          }
        } else {
          // 👇 DEFAULT END TIME = +15 MINUTES
          updatedEnd = startTime.add(15, "minute").format("HH:mm");
        }

        return {
          ...prev,
          start: value,
          end: updatedEnd,
        };
      }

      // END TIME NORMAL UPDATE
      return {
        ...prev,
        [field]: value,
      };
    });
  };

  const onSubmit = async () => {
    if (timeRange.start === timeRange.end) {
      setAlert({
        isVisible: true,
        message: "Start and End time cannot be the same",
        severity: "error",
      });
      return;
    }

    if (
      dayjs(`${bidDate}T${timeRange.end}`).isBefore(
        dayjs(`${bidDate}T${timeRange.start}`),
      )
    ) {
      setAlert({
        isVisible: true,
        message: "End time must be greater than start time",
        severity: "error",
      });
      return;
    }

    if (!bidDate || !timeRange.start || !timeRange.end) {
      setAlert({
        isVisible: true,
        message: "Please select a valid date and time range.",
        severity: "error",
      });
      return;
    }

    const bidOpenDate = dayjs(`${bidDate}T${timeRange.start}`).toISOString();
    const bidCloseDate = dayjs(`${bidDate}T${timeRange.end}`).toISOString();

    const formData = new URLSearchParams();
    formData.append("bid_open_date", bidOpenDate);
    formData.append("bid_close_date", bidCloseDate);

    try {
      setLoading(true);
      const response = await _sendAPIRequest(
        "PATCH",
        `${PortalApiUrls.UPDATE_BID}${bidDetails.id}/`,
        formData,
        true,
      );
      setLoading(false);
      if (response.status === 200) {
        setAlert({
          isVisible: true,
          message: "Bid dates updated successfully.",
          severity: "success",
        });
        setBidDetails((prevDetails) => ({
          ...prevDetails,
          bid_open_date: bidStartDate,
          bid_close_date: bidEndDate,
        }));
        if (onActionComplete) {
          onActionComplete();
        }
        dispatch(setActiveTab(3));
      }
    } catch (error) {
      setLoading(false);

      setAlert({
        isVisible: true,
        message: error.response?.data?.detail || "An error occurred.",
        severity: "error",
      });
    }
  };

  if (screenLoader) {
    return <ScreenLoader />;
  }

  return (
    <>
      <div className="container">
        <div className="row">
          {bidDetails?.type === "L1" && bidDetails?.bid_open_date === null ? (
            <>
              <Alert severity="warning" className="my-3">
                <p style={{ margin: 0 }}>
                  <strong>Warning:</strong>{" "}
                  <strong style={{ color: "red" }}>Please</strong> be careful
                  while filling in live bid dates, as they are non-editable once
                  set.
                </p>
              </Alert>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                    mt: 2,
                    width: "100%"
                  }}>
                  <Box
                    sx={{
                      flexBasis: { xs: "100%", sm: "48%", md: "23%" },
                      flexGrow: 1,
                    }}
                  >
                    <DatePicker
                      label="Live Bid Date"
                      value={bidDate ? dayjs(bidDate) : null}
                      minDate={dayjs()}
                      format="DD/MM/YYYY"
                      onChange={(value) =>
                        setBidDate(value?.format("YYYY-MM-DD") || null)
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          required: true,
                          style: {
                            height: "40px",
                            fontSize: "14px",
                          },
                        },
                      }}
                    />
                  </Box>

                  <Box
                    sx={{
                      flexBasis: { xs: "100%", sm: "48%", md: "23%" },
                      flexGrow: 1,
                      mt: { xs: 2, md: 0 },
                    }}
                  >
                    <DesktopTimePicker
                      label="Start Time"
                      value={
                        timeRange.start
                          ? dayjs(`${bidDate}T${timeRange.start}`)
                          : null
                      }
                      minutesStep={15}
                      disabled={!bidDate}
                      onChange={(value) =>
                        handleTimeChange(
                          "start",
                          value?.format("HH:mm") || null,
                        )
                      }
                      onAccept={(value) =>
                        handleTimeChange(
                          "start",
                          value?.format("HH:mm") || null,
                        )
                      }
                      closeOnSelect={false}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          style: {
                            height: "40px",
                            fontSize: "14px",
                          },
                        },
                      }}
                    />
                  </Box>

                  <Box
                    sx={{
                      flexBasis: { xs: "100%", sm: "48%", md: "23%" },
                      flexGrow: 1,
                      mt: { xs: 2, md: 0 },
                    }}
                  >
                    <DesktopTimePicker
                      label="End Time"
                      value={
                        timeRange.end
                          ? dayjs(`${bidDate}T${timeRange.end}`)
                          : null
                      }
                      minutesStep={15}
                      closeOnSelect={false}
                      onChange={(value) =>
                        handleTimeChange("end", value?.format("HH:mm") || null)
                      }
                      onAccept={(value) =>
                        handleTimeChange("end", value?.format("HH:mm") || null)
                      }
                      minTime={
                        timeRange.start
                          ? dayjs(`${bidDate}T${timeRange.start}`).add(
                              1,
                              "minute",
                            )
                          : undefined
                      }
                      disabled={!timeRange.start}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          style: {
                            height: "40px",
                            fontSize: "14px",
                          },
                        },
                      }}
                    />
                  </Box>

                  <Box
                    sx={{
                      flexBasis: { xs: "100%", sm: "48%", md: "23%" },
                      flexGrow: 1,
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      disabled={loading}
                      sx={{
                        width: "100%",
                        height: "56px",
                        fontSize: "14px",
                        mt: { xs: 2, md: 0 },
                      }}
                      className={classNames("btn", "button")}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </Button>
                  </Box>
                </Box>
              </form>
            </>
          ) : (
            <></>
          )}
        </div>
        <Accordion
          defaultExpanded
          square={true}
          classes={{
            root: `custom-accordion ${styles["bids-detail-accordion"]}`,
          }}
        >
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography classes={{ root: "custom-accordion-heading" }}>
              Invited Suppliers
            </Typography>
          </AccordionSummary>

          <Box
            sx={{
              display: "flex",
              gap: 3,
              mb: 2,
              justifyContent: "center",
              flexWrap: "wrap"
            }}>
            <Button
              variant="contained"
              className={`${styles["stat-button"]} ${styles.invited}`}
            >
              Invited : 0{participant.invited_count}
            </Button>

            <Button
              variant="contained"
              className={`${styles["stat-button"]} ${styles.accepted}`}
            >
              Accepted : 0{participant.accepted_count}
            </Button>

            <Button
              variant="contained"
              className={`${styles["stat-button"]} ${styles.participated}`}
            >
              Participated : 0{participant.participated_count}
            </Button>

            <Button
              variant="contained"
              className={`${styles["stat-button"]} ${styles.declined}`}
            >
              Declined : 0{participant.rejected_count}
            </Button>
            <Button
              variant="contained"
              className={`${styles["stat-button"]} ${styles.revoked}`}
            >
              Revoked : 0{participant.revoked_count}
            </Button>
          </Box>

          <AccordionDetails>
            <DataTable
              propsColumn={l1_participants_column}
              propsData={
                bidDetails?.type === "L1"
                  ? participant.participants
                  : filteredParticipants
              }
              action={addAction}
            />
          </AccordionDetails>
        </Accordion>
      </div>
      {deleteDetails?.open && (
        <DeleteDialog
          title={deleteDetails.title}
          message={deleteDetails.message}
          handleClick={handleDeleteConfirmation}
          isUndo={deleteDetails?.isUndo}
        />
      )}
    </>
  );
};

export default InvitedSuppliers;
